import {
  configureStore,
  createSerializableStateInvariantMiddleware,
} from '@reduxjs/toolkit';
import modalReducer from 'src/redux/modals/slice';
import jobReducers from 'src/redux/jobs/slice';
import openJobsReducer from 'src/redux/open-jobs/slice';
import quoteApproval from 'src/redux/quote-approval/slice';
import partnerReducer from 'src/redux/partner-integration/slice';
import flagSummaryReducer from 'src/redux/flag-summary/slice';
import { embedApi } from 'src/redux/embed/api';

const serializableMiddleware = createSerializableStateInvariantMiddleware({
  ignoredActions: [
    'uploadAttachment/pending',
    'uploadAttachment/fulfilled',
  ],
  ignoredActionPaths: [
    /^payload\.data\.attachments\.\d+\.file$/,
    /^meta\.baseQueryMeta/,
  ],
  ignoredPaths: [
    /^jobDetails\.messages\.data\.\w+\.content\.\d+\.attachments\.\d+\.file$/,
  ],
});

const store = configureStore({
  reducer: {
    modals: modalReducer,
    jobDetails: jobReducers,
    openJobs: openJobsReducer,
    quoteApproval,
    partnerIntegration: partnerReducer,
    flagSummary: flagSummaryReducer,
    [embedApi.reducerPath]: embedApi.reducer,
  },

  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  })
    .concat(serializableMiddleware)
    .concat(embedApi.middleware),

  devTools: {
    serialize: {
      options: {
        set: true,
      },
    },
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
